export default function isNullOrEmpty(str) {
    return !str || str.trim().length === 0;
}